interface IObject {
  [key: string]: unknown;
}

export function isPropertyDefined<T extends IObject>(
  obj: T,
  property: string
): boolean {
  if (obj === null || obj === undefined) {
    return false;
  }
  if (
    obj.hasOwnProperty(property) &&
    obj[property] !== undefined &&
    obj[property] !== null &&
    obj[property] !== ''
  ) {
    return true;
  }
  const keys = Object.keys(obj);

  for (const key of keys) {
    if (typeof obj[key] === 'object') {
      if (isPropertyDefined(obj[key] as IObject, property)) return true;
    }
  }
  return false;
}

export function getKeysWithUndefinedValue<T>(obj: T): Set<string> {
  const keys: Set<string> = new Set<string>();
  Object.keys(obj as Record<string, unknown>).forEach((key) => {
    const value = (obj as Record<string, unknown>)[key];
    if (value === undefined || value === null || value === '') {
      keys.add(key);
    } else if (typeof value === 'object') {
      getKeysWithUndefinedValue(value).forEach((val) => {
        keys.add(val);
      });
    }
  });
  return keys;
}

export function hasDefinedFields<T>(obj: T, excpetions?: string[]): boolean {
  const objRecord = obj as Record<string, unknown>;
  return Object.keys(objRecord).some((key) => {
    const value = objRecord[key];
    if (typeof value === 'object' && value !== null) {
      return hasDefinedFields(value, excpetions);
    }
    if (value !== undefined && value !== null && value !== '') {
      return !excpetions || !excpetions.includes(key);
    }
    return false;
  });
}

export function hasUndefinedFields<T>(obj: T, excpetions?: string[]): boolean {
  if (obj === null || obj === undefined) return true;

  const objRecord = obj as Record<string, unknown>;
  return Object.keys(objRecord).some((key) => {
    const value = objRecord[key];
    if (typeof value === 'object' && value !== null) {
      return hasUndefinedFields(value, excpetions);
    }
    if (value === undefined || value === null || value === '') {
      return !excpetions || !excpetions.includes(key);
    }
    return false;
  });
}

export function nameof<T>(name: keyof T): string {
  return name as string;
}

/**
 * Removes all properties with null, undefined, or empty string values from an object
 * @param obj - The object to clean
 * @returns A new object with all null, undefined, and empty string values removed
 */
export function removeEmptyValues<T extends Record<string, unknown>>(
  obj: T
): Partial<T> {
  const result: Partial<T> = {};

  Object.entries(obj).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      result[key as keyof T] = value as T[keyof T];
    }
  });

  return result;
}
